import { useContext, createContext } from 'react';
import getContext, { iSettings } from '../context/AppSettingsContext';
import { useAppSettingsStateStore } from '../context/AppSettingsStateContext';

// Fallback context that always exists to ensure hooks are called consistently
const FallbackContext = createContext<iSettings | null>(null);

export const useAppSettings = () => {
    // Always call all hooks unconditionally, in the same order
    const { isGettingAppSettings } = useAppSettingsStateStore();

    // Get the context dynamically
    const AppSettingsContext = getContext();

    // Always call useContext - use the real context if available, otherwise use fallback
    // This ensures hook order is consistent across renders
    const contextSettings = useContext(AppSettingsContext ?? FallbackContext);

    return {
        settings: contextSettings,
        isLoading: isGettingAppSettings,
    };
};
